import * as types from "./types";
import { requestAuth } from "../helpers/FetchApi";
import appSettings from "../AppSettings";
import { toast } from "react-toastify";
import strings from "../helpers/Localization";

export const actionCreators = {
    GetErrorReports: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => async (dispatch, store) => {

        dispatch({ type: types.GET_ERROR_REPORTS_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ErrorReport?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_ERROR_REPORTS_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    GetErrorReport: (id) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/ErrorReport/" + id,
            {
                method: "GET"
            })
            .then((data) => {
                dispatch({ type: types.GET_ERROR_REPORT_COMPLETED, payload: data });
            })
            .catch( (data) => {
                console.log(data);
            });
    },
    ClearErrorReport: () => (dispatch, store) => {
        dispatch({ type: types.CLEAR_ERROR_REPORT });
    },

    GetOrganizations: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Organizations?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        ,
        {
            method: "GET"
        })
            .then((data) => {
                data.sortExpression = sortExpression;
                data.filterExpression = filterExpression;
                data.tagSearchRequest = tagSearchRequest;
                data.PaginationType = PaginationType;
                dispatch({ type: types.GET_ORGANIZATIONS_COMPLETED, payload: data });
                return onSuccess(data);
            })
            .catch( (data) => {
                console.log(data);
            });
    },
    EnableOrganization: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Organizations/Enable/" + id,
            {
                method: "GET"
            })
            .then((data) => {
                toast.success(strings.orgEnabled);
                if (onSuccess) {onSuccess(data);}
            })
            .catch( (data) => {
                console.log(data);
            });
    },
    DisableOrganization: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Organizations/Disable/" + id,
            {
                method: "GET"
            })
            .then((data) => {
                toast.success(strings.orgDisabled);
                if (onSuccess) {onSuccess(data);}
            })
            .catch( (data) => {
                console.log(data);
            });
    },
    CreateOrganization: (obj, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Organizations/",
            {
                method: "POST",
                body: obj
            })
            .then((data) => {
                toast.success(strings.orgCreated);
                if (onSuccess) {onSuccess(data);}
            })
            .catch( (data) => {
                console.log(data);
            });
    },
    GetOrganizationAdmin: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Organizations/" + id,
            {
                method: "GET"
            })
            .then((data) => {
                onSuccess(data);
            })
            .catch( (data) => {
                console.log(data);
            });
    },
    EditOrganization: (obj, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Organizations/" + store().currentuser.currentorganization.id, {
            body: obj,
            method: "PUT"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });

    }
};


